import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllSupportItems,
  getAllSupportTickets,
} from "../CrudAndRedux/ProfileCrud";
import { actions } from "../CrudAndRedux/ProfileRedux";
import AddBtn from "../Support/AddBtn";
import SupportCards from "./SupportCards";

const Support = (props) => {
  const { state } = useSelector((state) => ({
    state: state.search,
  }));

  const { state: profileState } = useSelector((state) => ({
    state: state.profile,
  }));

  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));


  const dispatch = useDispatch();

  React.useLayoutEffect(() => {
      getAllSupportTickets(authState.user.token).then((res) => {
        dispatch(actions.getAllSupportTickets(res.data.data));
        console.log("supportTickets", res.data.data);
      });

      getAllSupportItems(authState.user.token).then((res) => {
        dispatch(actions.getAllSupportItems(res.data.data));
        console.log("supportItems", res.data.data);
      });
    
  }, []);

  return (
    <div className='p-5'>
      {profileState.supportItems && profileState.supportTickets ? (
        <>
          <AddBtn supportItems={profileState.supportItems} />
          <SupportCards supportTickets={profileState.supportTickets} />
        </>
      ) : (
        <div style={{ marginTop: "1rem" }} className='container'>
          <SkeletonTheme baseColor="#d9dce6" highlightColor="darkgray">
            <Skeleton
              count={1}
              style={{
                height: "40px",
                width: "15%",
                marginBlock: 10,
                borderRadius: 13,
              }}
            />

            <Skeleton count={5} style={{ height: "10rem", marginBlock: 10 }} />
          </SkeletonTheme>
        </div>
      )}
    </div>
  );
};

export default Support;
